module.exports = "https://static.wagwalking.com/_next/static/images/dog-sitting-2-5a9efd976d2f0d6f3a8bc405b7198ac8.svg";